import { isDefined } from '@components/config/helpers';
import { produce } from 'immer';
import { createContext, useContext, useState } from 'react';
const ProductExtraContext = createContext();

const EMPTY = {
    // image: '/images/no-image.jpg',
    image: null,
    image_zoom: null,
    value: 'None'
}

export const ProductExtrasProvider = ({ children }) => {

    const [extrasSelected, setExtrasSelected] = useState({});

    const findExtra = (primary_product_id, extra) => {
        const data = {
            value: extra.product_id,
            image: extra.image,
            image_zoom: extra.image_zoom,
            product_slug: extra.product_slug,
            product_extra_product_id: extra.product_id,
            extra_type: extra.product_extras_group_slug,
            product_extras_group_id: extra.product_extras_group_id,
            product_extras_to_group_id: extra.product_extras_to_group_id

        }
        setExtrasSelected(prevState => produce(prevState, draft => {
            if (!draft?.[primary_product_id]) draft[primary_product_id] = {}
            draft[primary_product_id] = {
                ...draft[primary_product_id],
                [data.extra_type]: data
            }
        }))

    }


    const handleSelected = (e, object = {}) => {
        if (!isDefined(e)) {
            setExtrasSelected(prevState => produce(prevState, draft => {
                if (!draft?.[object.primary_product_id]) draft[object.primary_product_id] = {}
                let data = {}
                if (object.isMandatory) {
                    data.value = object.extras[0].product_id;
                    data.image = object.extras[0].image;
                    data.image_zoom = object.extras[0].image_zoom;
                    data.product_slug = object.extras[0].product_slug;
                    data.product_extras_group_id = object.extras[0].product_extras_group_id;
                    data.product_extras_to_group_id = object.extras[0].product_extras_to_group_id;
                    data.primary_product_id = object.primary_product_id;
                    data.extra_type = object.type;
                }
                else {

                    data.value = EMPTY.value;
                    data.image = EMPTY.image;
                    data.image_zoom = EMPTY.image_zoom;
                    data.product_slug = null;
                    data.product_extras_group_id = object.product_extras_group_id;
                    data.product_extras_to_group_id = object.product_extras_to_group_id;
                    data.product_extra_product_id = object.product_extra_product_id,
                        data.extra_type = object.type
                }
                draft[object.primary_product_id][object.type] = data;
            }))
        }
        else {
            const foundExtra = object.extras.find(product_extra => product_extra.product_id == e.target.value)
            let extra = {
                product_slug: foundExtra?.product_slug || null,
                image: foundExtra?.image || EMPTY.image,
                image: foundExtra?.image_zoom || EMPTY.image_zoom,
                product_id: foundExtra?.product_id || e.target.value,
                product_extras_group_slug: object.type,
                product_extras_group_id: object.product_extras_group_id,
                product_extras_to_group_id: object.product_extras_to_group_id
            }
            findExtra(object.primary_product_id, { ...extra, ...foundExtra });
        }
    }

    return (
        <ProductExtraContext.Provider value={{
            extrasSelected,
            setExtrasSelected,
            handleSelected
        }}>
            {children}
        </ProductExtraContext.Provider>
    );
}

export const useProductExtras = () => useContext(ProductExtraContext);
